import { Box, TextField, InputAdornment, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const StrategySearchBar = ({ value, onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        placeholder="Search strategies..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: theme.palette.text.secondary }} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 1,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: theme.palette.divider,
            },
            "&:hover fieldset": {
              borderColor: theme.palette.primary.main,
            },
          },
        }}
      />
    </Box>
  );
};

export default StrategySearchBar;
